<ul *ngIf="sidemenuService.productsVisible">
    <div>
        <mat-checkbox (change)="showFilteredProducts($event)">
            Nach aktiven Produkten filtern
        </mat-checkbox>
    </div>
</ul>
<ul>
    <ng-container *ngFor="let button of sidemenuService.sidemenuData">
        <app-sidemenu-button *ngIf="button" [label]="button.label" [link]="button.link"
            [addButton]="button.addButton" [children]="button.children" [hasChildren]="button.hasChildren"
            [entityId]="button.entityId" [ptgId]="button.ptgId" [usecaseId]="button.usecaseId"
            [belongsToOrganisation]="button.belongsToOrganisation" [composerItem]="button.composerItem"
            [clicked]="button.clicked" [type]="button.type" [rating]="button.rating"
            [isCertification]="button.isCertification" [imageId]="button.imageId" [disabled]="button.disabled" [disabledReason]="button.disabledReason">
        </app-sidemenu-button>
    </ng-container>
</ul>

<!-- border element on the right -->
<div class="border-line-element-container">
    <div class="border-line-element-first"></div>
    <div class="border-line-element-second"></div>
</div>
